import { useContext, useState } from 'react';
import { NotificationContext, UserContext } from '../App';
import Frame from '../layout/Frame';
import Panel from '../layout/Panel';
import { Checkbox, UpdateName, UpdatePassword } from '../components';
import { updateEnableAlerting } from '../requests/requests';
import { SnackbarType } from '../types/enums';
import { User } from '../types/types';
import Toggle from '../components/Toggle/Toggle';

const Profile = () => {
  const { user, setUser } = useContext(UserContext);
  const notify = useContext(NotificationContext);
  const [isAlerting, setIsAlerting] = useState(user?.hasAlertsEnabled ?? false);

  const onAlertingChange = () => {
    const newValue = !isAlerting;
    setIsAlerting(newValue);
    updateEnableAlerting(newValue).then(
      () => {
        setUser({
          ...user,
          hasAlertsEnabled: newValue
        } as User);
        notify('Alerting has been updated!', SnackbarType.SUCCESS);
      },
      () => {
        notify('Could not update alerting, please reach out to us!', SnackbarType.ERROR);
        setIsAlerting(user?.hasAlertsEnabled ?? false);
      }
    );
  };

  return (
    <Frame>
      <Panel>
        <h1>Profile</h1>
        <UpdateName />
        <UpdatePassword />

        <p>
          <strong>Email Alerts for Downtime</strong>
        </p>
        <p>
          Get an email whenever any of your monitored websites goes down. Stay informed, stay in
          control.
        </p>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <Toggle action={onAlertingChange} active={isAlerting} />
          Send me email alerts if anything goes down
        </div>
      </Panel>
    </Frame>
  );
};

export default Profile;
